import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainMenuComponent } from './components/main-menu/main-menu.component';
import { StartGameMenuComponent } from './components/start-game-menu/start-game-menu.component';
import { GameComponent } from './components/game/game.component';
import { PopupMenuComponent } from './subcomponents/popup-menu/popup-menu.component';
import { EndGameComponent } from './components/end-game/end-game.component';
import { CookieService } from './services/cookie.service';
import { TranslatePipe } from './pipes/translate.pipe';
import { ScoreStringPipe } from './pipes/score-string.pipe';
import { AriaTranslatePipe } from './pipes/aria-translate.pipe';

@NgModule({
  declarations: [
    AppComponent,
    MainMenuComponent,
    StartGameMenuComponent,
    GameComponent,
    PopupMenuComponent,
    EndGameComponent,
    TranslatePipe,
    ScoreStringPipe,
    AriaTranslatePipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatButtonModule,
    MatIconModule,
    MatSlideToggleModule
  ],
  providers: [CookieService],
  bootstrap: [AppComponent]
})
export class AppModule { }
